import { IValue } from '../exception-validator';

export function setWholeDaySchedule(hoursDay): IValue {
  let {hoursFirstValueFirstArray, hoursSecondValueFirstArray} = hoursDay;

  if (hoursFirstValueFirstArray === '') {
    hoursFirstValueFirstArray = {
      hours: 0,
      minutes: 0,
    };
  }

  if (hoursSecondValueFirstArray === '') {
    hoursSecondValueFirstArray = {
      hours: 23,
      minutes: 59,
    };
  }

  return {...hoursDay, hoursSecondValueFirstArray, hoursFirstValueFirstArray};
}

export function setWholeDayForAlreadyExistsSchedule(hoursDay) {
  const { hours } = hoursDay;

  return hours.map(range => {
    return range.map((timestamp, i) => {
      if (timestamp === '') {
        return {
          hours: i === 0 ? 0 : 23,
          minutes: i === 0 ? 0 : 59,
        };
      }

      return timestamp;
    });
  });
}
